import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, devUser, loading, error } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <div>ロード中...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            padding: "20px",
            border: "1px solid #d32f2f",
            borderRadius: "4px",
            backgroundColor: "#ffebee",
            color: "#d32f2f",
          }}
        >
          {error}
        </div>
      </div>
    );
  }

  if (!user && !devUser) return <Navigate to="/login" replace />;

  return <>{children}</>;
};
